import React from 'react';
import {
  DemoPackageCommunityAddOn,
  DemoPackageFloorplanAddOns,
  DemoPackageFloorplanInclude,
  DemoPackagePhotoAddOns,
  DemoPackagePhotoInclude,
} from '~/tenants/demo/package/common';
import { TenantPackageIncludes } from '~/tenants/common/package';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import { PersonaType } from '~/tenants/common/TenantPersona';

export default function DemoPackageBasicForm() {
  return (
    <>
      <TenantPackageIncludes>
        <DemoPackagePhotoInclude />
        <DemoPackageFloorplanInclude />
      </TenantPackageIncludes>
      <TenantPerformableAddOns persona={PersonaType.CUSTOMER}>
        <DemoPackagePhotoAddOns />
        <DemoPackageFloorplanAddOns />
        <DemoPackageCommunityAddOn />
      </TenantPerformableAddOns>
    </>
  );
}
